import React from 'react';

export default ({ className = '' }) => (
  <div className={`py-3 my-3 py-md-4 my-md-4 py-lg-5 my-lg-5 ${className}`} />
);


// WEBPACK FOOTER //
// ./src/components/Break.js